import { defineMessages } from 'react-intl'

/**
 * On-tile / on-PDP product badges (see `docs/product-taxonomy.md` §2). LE vs
 * white-label variants are separate keys: pick the right one at the call site.
 */
const productBadgeMessages = defineMessages({
  limitedTimeLuxExclusiveLe: {
    id: 'HfKQTJhSrYcq7b38i0nx',
    defaultMessage: 'Limited Time LUX Exclusive',
    description: 'Product label for limited time LUX exclusive flash hotel and cruise offers on tiles',
  },
  limitedTimeLuxExclusiveWl: {
    id: 'ELOGmElRhyYa89yQYHOq',
    defaultMessage: 'Limited Time Exclusive',
    description: 'Product label for limited time exclusive flash offers for white-label brands on tiles',
  },
  luxPremiumCollectionLe: {
    id: '0jJ1Jh_HXb3h9DjB0XXB',
    defaultMessage: 'LUX Premium Collection',
    description: 'Product label for LUX premium collection tactical always-on hotel and cruise offers',
  },
  luxPremiumCollectionWl: {
    id: 'xpAmBYCbIAhmAcdsmzwV',
    defaultMessage: 'Premium Collection',
    description: 'Product label for premium collection tactical always-on offers for white-label brands',
  },
  lastMinuteEscape: {
    id: 'rAFzz16P-wPa5Ili6u6Q',
    defaultMessage: 'Last Minute Escape',
    description: 'Product type label for last minute escape hotel offers on tiles and list views',
  },
  luxPartnerPropertyLe: {
    id: 'mJhLgeIBs6OHzRxl1lwU',
    defaultMessage: 'LUX Partner Property',
    description: 'Product type label for LUX partner property bedbank and wholesaler inventory on tiles',
  },
  luxPartnerPropertyWl: {
    id: 'X0dft71-n3yhpjcLSvE5',
    defaultMessage: 'Partner Property',
    description: 'Product label for partner property bedbank offers for white-label brand surfaces',
  },
  luxExclusive: {
    id: '46ebreLwGtvpulRl_x0E',
    defaultMessage: 'LUX Exclusive',
    description: 'Product label for LUX exclusive direct tours, flash experiences, and exclusive cruises',
  },
  luxTrustedPartner: {
    id: 'LwpI9uTLS5DzMFQUh7X2',
    defaultMessage: 'LUX Trusted Partner',
    description: 'Product label for LUX trusted partner tours and similar partner-sourced product tiles',
  },
  luxCollection: {
    id: 'kMTGjHTfmSzzG1dGdu1A',
    defaultMessage: 'LUX Collection',
    description: 'Product type label for LUX collection channel manager and always-on experience offers',
  },
  ultraLuxBadgeAccessibilityLabel: {
    defaultMessage: 'Ultra Lux',
    id: 'Lya0JZkonxQZR_kP3MIx',
    description: 'Screen reader label for the Ultra Lux logo badge on ultra-luxury hotel and tour tiles',
  },
  bundleAndSave: {
    id: 'NWHhUN-YWk-WLCZeyRst',
    defaultMessage: 'Bundle & Save',
    description: 'Product label for bundle and save package offers on the offer page and product tiles',
  },
  limitedTimeSpecial: {
    id: 'oTAYW0h-XtuHGdkRFP-7',
    defaultMessage: 'Limited time special',
    description: 'Product type label for limited time special tactical and promotional product tiles',
  },
  businessTravellerSpecial: {
    id: 'RSDZTaR-HjAxszAR140b',
    defaultMessage: 'Business Traveller Special',
    description: 'Product type label for corporate and business traveller special offers on product tiles',
  },
})

export default productBadgeMessages
